import { render } from "./popupProduct.vue?vue&type=template&id=1e70e144"
import script from "./popupProduct.vue?vue&type=script&lang=js"
export * from "./popupProduct.vue?vue&type=script&lang=js"

import "./popupProduct.vue?vue&type=style&index=0&id=1e70e144&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__